// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/loss_rate_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/loss_rate_model.proto.
 */
export const file_bffuser_v1_loss_rate_model: GenFile = /*@__PURE__*/
  fileDesc("CiBiZmZ1c2VyL3YxL2xvc3NfcmF0ZV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSKmAQoTTG9zc1JhdGVBcmVhU2V0dGluZxIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIsCgdjdXJyZW50GAIgASgLMhsuYmZmdXNlci52MS5Mb3NzUmF0ZVNldHRpbmcSLgoEbmV4dBgDIAEoCzIbLmJmZnVzZXIudjEuTG9zc1JhdGVTZXR0aW5nSACIAQFCBwoFX25leHQi4AEKD0xvc3NSYXRlU2V0dGluZxIKCgJpZBgBIAEoCRIuChBsb3dfdm9sdGFnZV9yYXRlGAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBIvChFoaWdoX3ZvbHRhZ2VfcmF0ZRgDIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwSNQoXZXh0cmFfaGlnaF92b2x0YWdlX3JhdGUYBCABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsEikKDmVmZmVjdGl2ZV9kYXRlGAUgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_google_type_date, file_google_type_decimal]);

/**
 * LossRateAreaSetting holds the loss-rate configuration for a single
 * area. Each area carries a "current" (ACTIVE) setting (always present)
 * and an optional "next" (SCHEDULED) setting (absent when no upcoming
 * revision is scheduled).
 *
 * @generated from message bffuser.v1.LossRateAreaSetting
 */
export type LossRateAreaSetting = Message<"bffuser.v1.LossRateAreaSetting"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bffuser.v1.LossRateSetting current = 2;
   */
  current?: LossRateSetting;

  /**
   * @generated from field: optional bffuser.v1.LossRateSetting next = 3;
   */
  next?: LossRateSetting;
};

/**
 * Describes the message bffuser.v1.LossRateAreaSetting.
 * Use `create(LossRateAreaSettingSchema)` to create a new message.
 */
export const LossRateAreaSettingSchema: GenMessage<LossRateAreaSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_loss_rate_model, 0);

/**
 * LossRateSetting represents one loss-rate setting record. Each
 * voltage class rate is expressed as a percentage with one decimal
 * digit precision (e.g. 6.9).
 *
 * @generated from message bffuser.v1.LossRateSetting
 */
export type LossRateSetting = Message<"bffuser.v1.LossRateSetting"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Decimal low_voltage_rate = 2;
   */
  lowVoltageRate?: Decimal;

  /**
   * @generated from field: google.type.Decimal high_voltage_rate = 3;
   */
  highVoltageRate?: Decimal;

  /**
   * @generated from field: google.type.Decimal extra_high_voltage_rate = 4;
   */
  extraHighVoltageRate?: Decimal;

  /**
   * @generated from field: google.type.Date effective_date = 5;
   */
  effectiveDate?: Date;
};

/**
 * Describes the message bffuser.v1.LossRateSetting.
 * Use `create(LossRateSettingSchema)` to create a new message.
 */
export const LossRateSettingSchema: GenMessage<LossRateSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_loss_rate_model, 1);

